module.exports = __webpack_public_path__ + "img/S3Large.5183d4c2.png";